






































import Vue from 'vue'
import {Component, Inject} from 'vue-property-decorator'
import { autorun } from 'mobx'
import {Observer} from 'mobx-vue'
import PerfectScrollbar from 'perfect-scrollbar'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import { getAppLinks } from '../../../rundeckService'
import {RootStore} from '../../../stores/RootStore'
import { ProjectStore, Project } from '../../../stores/Projects'
import Skeleton from '../../skeleton/Skeleton.vue'

RecycleScroller.updated = function() {
    if (!this.ps)
        this.$nextTick().then(() => {this.ps = new PerfectScrollbar(this.$el, {minScrollbarLength: 20})})
    else
        this.ps.update()
}

const destroy = RecycleScroller.beforeDestroy
RecycleScroller.beforeDestroy = function() {
    destroy.bind(this)()
    if (this.ps) {
        try {
            this.ps.destroy()
            this.ps = null
        } catch {}
    }
}

@Observer
@Component({components: {
    RecycleScroller,
    Skeleton
}})
export default class ProjectSelect extends Vue {
    @Inject()
    private readonly rootStore!: RootStore

    projects!: ProjectStore

    ps!: PerfectScrollbar

    searchTerm: string = ''

    get allProjectsLink(): string {
        return getAppLinks().menuHome
    }

    created() {
        this.projects = this.rootStore.projects
        this.projects.load()
    }

    mounted() {
        autorun(() => {
            if (this.projects.projects.length) {
                /** May be necessary for virtual scroller to update */
                this.$forceUpdate()
            }
        })
        this.$nextTick().then(() => {
            (<HTMLElement>this.$refs['search']).focus()
        })
    }

    itemClicked(project: Project) {
        this.$emit('project:selected', project)
    }

    allClickekd() {
        this.$emit('project:select-all')
    }
}
